'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchQueryShape = _reactImmutableProptypes2.default.contains({
  pagination_page: _react.PropTypes.number,
  query: _react.PropTypes.string,
  searchType: _react.PropTypes.string
});

exports.default = searchQueryShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/searchQueryShape.js
// module id = 531
// module chunks = 1